module.exports = __webpack_public_path__ + "img/1.655e3f44.svg";